module.exports = __webpack_public_path__ + "static/img/yytx06.a5abd71.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx06.png
// module id = 878
// module chunks = 0